import React, { Component } from 'react';

import Invoice from './invoice_prem';
import Product from './product_prem';
import favicon from './../../statics/img/favicon.png';
import './checkout_prem.scss'
class checkout extends Component {
  
  render() {
    var search = window.location.search.substring(1);
    let objectData = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
    
    let page_token = objectData.ref;
    let ref_page = page_token.substr(0, 1);
    let ref_token = page_token.substr(2);

    return (
      <div className="App checksPerm">
        {ref_page === "i"?
          <Invoice token={ref_token} />
        :
          null
        }
        {ref_page === "p"?
          <Product token={ref_token} />
        :
          null
        }
      </div>
    );
  }
}

export default checkout;
